import * as L from './List.styled';

export default L.List;
